import { render } from "./SignUpRemote.vue?vue&type=template&id=085f7522&scoped=true&ts=true"
import script from "./SignUpRemote.vue?vue&type=script&lang=ts"
export * from "./SignUpRemote.vue?vue&type=script&lang=ts"

import "./SignUpRemote.vue?vue&type=style&index=0&id=085f7522&scoped=true&lang=css"

import exportComponent from "/Users/pontustengroth/Desktop/git/shipd/apps/shipd-website/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-085f7522"]])

export default __exports__